module.exports = __webpack_public_path__ + "img/frame-login-mb.54c616df.webp";